import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'
import Tabs from '../stories/Tabs/Tabs'
import Meta from '../common/Meta'
import { useSingleMatch } from './api'
import MatchHeader from '../common/components/header/MatchHeader'
import classes from './Matches.module.css'
import { IconChevronLeft } from '@tabler/icons-react'

export default function MatchDetailsLayout() {
  const { competitionId, matchId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { data: match } = useSingleMatch({
    competition_id: Number(competitionId),
    match_id: Number(matchId),
  })
  const isDesktop = useMediaQuery('(min-width: 800px)')

  const [activeTab, setActiveTab] = useState<string>('')
  const tabs = [{ value: 'summary', label: 'Summary' }]

  useEffect(() => {
    const path = location.pathname
      .split('/matches/')[1]
      ?.split('/')
      .slice(1)
      .join('/')
    setActiveTab(path ?? '')
  }, [location])

  if (match.away_team_id) {
    tabs.push({
      value: `${match.home_team_id}/history/${match.away_team_id}`,
      label: 'H2H History',
    })
  }

  if (match.video?.main) {
    tabs.push({
      value: 'watch',
      label: 'Watch Match',
    })
  }

  return (
    <div className={classes.container}>
      <Meta title="Match" />
      <div className={classes.headerContainer}>
        {isDesktop && (
          <IconChevronLeft
            onClick={() => navigate(-1)}
            className={classes.backIcon}
          />
        )}
        <MatchHeader match={match} />
      </div>
      <div
        className={clsx(classes.matches_details_container, {
          [classes.matches_details_container_mobile]: !isDesktop,
        })}
      >
        <div
          className={clsx(classes.matchesTabs, {
            [classes.matchesTabsMobile]: !isDesktop,
          })}
        >
          <Tabs items={tabs} value={activeTab} onChange={setActiveTab} isLink />
        </div>
        <Outlet />
      </div>
    </div>
  )
}
